import React from 'react';
import { TooltipRenderProps } from 'react-joyride';

const CustomTooltipProgress = (props: TooltipRenderProps) => {
  return (
    <div
      className={
        'bg-neutral-chalk rounded-2xl p-4 max-w-[280px] font-bold text-sm leading-[19px] text-neutral-pencil'
      }
    >
      {props.step.content}
    </div>
  );
};

export default CustomTooltipProgress;
